import CustomFormControl from "@Modules/core/components/form/CustomFormControl"
import CustomInput, { INPUT_TYPE } from "@Modules/core/components/form/CustomInput"
import CustomTextArea from "@Modules/core/components/form/CustomTextArea"
import { getFormFieldsName } from "./getFormFieldsNames"

export default function displayCustomTextareas<T>(meta: any, register: any, errors: any, isLoading?: boolean, inputs?: string[], excluded?: string[]) {
    // const arr = (inputs && inputs?.length > 0) ? inputs : getFormFieldsName(meta, excluded);
    let arr: string[] = [];

    const excludedArray = excluded ? [...excluded, "schema"] : ["schema"];

    if(inputs && inputs?.length > 0) {
        // console.table(excludedArray);
        
        for (let input of inputs) {
            !excludedArray.includes(input) && arr.push(meta[input as keyof T].name);
        }
    } else arr = getFormFieldsName(meta, excludedArray);

    return arr.map((input, index) => {
        const hasLabel = meta[input as keyof T].type !== INPUT_TYPE.CHECKBOX
        return (
            <CustomFormControl key={index} isLoading={isLoading} label={ hasLabel && meta[input as keyof T].label} isInvalid={!!errors[meta[input as keyof T].name]}>
                {/* <CustomInput hasError={errors[meta[input as keyof T].name]} register={register(meta[input as keyof T].name)} meta={meta[input as keyof T]}/> */}
                <CustomTextArea hasError={errors[meta[input as keyof T].name]} register={register(meta[input as keyof T].name)} meta={meta[input as keyof T]}/>

            </CustomFormControl>
            
        )
    })
};